const ChatError = Object.freeze({
  ConnectionFailed: 'CHAT_CONNECTION_FAILED',
  JoinRoomFailed: 'CHAT_JOIN_ROOM_FAILED',
  InitPersonalChatFailed: 'CHAT_INIT_PERSONAL_CHAT_FAILED',
  ListUsersFailed: 'CHAT_LIST_USERS_FAILED',
  MessagesHistoryFailed: 'MESSAGES_HISTORY_FAILED',
});

export default ChatError;
